var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block center"},[_c('div',[_c('p',{staticClass:"no-data"},[_vm._v("No Data In Database")])])])}]

export { render, staticRenderFns }